import { PreviewCreative, PreviewVersion } from "utils/Preview";

export const SHARE_CREATIVE_PREVIEWS_FORM = "ShareCreativePreviews";

export function buildSharableLink(publicId, creative, useVersionLinks, forceNewPreview) {
	const fn = useVersionLinks ? PreviewVersion.public : PreviewCreative.public;
	return fn({ ...creative, id: publicId }, forceNewPreview).url;
}

export function buildBulkSharableLink(publicId, links = [], useVersionLinks, forceNewPreview) {
	/*
		One of the links may be the link for the batch, which doesn't have a creative,
		but `creative` may be an empty object, so we just do a basic check for keys,
		so we don't factor it in when determining if a legacy preview creative is present.
	*/
	const legacyLink = links.find(link => (Object.keys(link.creative).length && PreviewCreative.public(link.creative, forceNewPreview).isLegacy));
	const creative = legacyLink?.creative || links.find(link => Object.keys(link.creative).length)?.creative;
	return buildSharableLink(publicId, creative, useVersionLinks, forceNewPreview);
}
